import { Component, input, Input, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { AsyncPipe, NgClass } from '@angular/common';
import { NgScrollbar } from 'ngx-scrollbar';
import dayjs from 'dayjs';
import { delay, takeUntil } from 'rxjs/operators';
import { ofType } from '@ngrx/effects';
import { PageLoadingComponent } from '../../../page-loading/page-loading.component';
import { FloatingInputComponent } from '../../../inputs/floating-input/floating-input.component';
import { InputCalendarComponent } from '../../../inputs/input-calendar/input-calendar.component';
import { DropdownComponent } from '../../../inputs/dropdown/dropdown.component';
import { ProjectSetupBaseComponent } from '../project-setup-base.component';
import { projectActions } from '../../../../store/projects/projects.actions';
import { GCProject } from '../../../../pages/webapp/projects/projects.interface';
import { TooltipDirective } from '@app/directives/tooltip.directive';
import { US_STATES } from '@app/framework/constants/states.constants';
import { DeepCopyService } from '@app/services/deep-copy.service';

@Component({
  selector: 'app-project-setup-gc',
  imports: [
    FormsModule,
    TooltipDirective,
    AsyncPipe,
    PageLoadingComponent,
    NgScrollbar,
    NgClass,
    FloatingInputComponent,
    InputCalendarComponent,
    DropdownComponent,
  ],
  templateUrl: './project-setup-gc.component.html',
  styleUrl: './project-setup-gc.component.scss',
})
export class ProjectSetupGcComponent extends ProjectSetupBaseComponent implements OnInit {
  @Input() isEdit: boolean;
  isInvitationAccept = input<boolean>(false);

  @ViewChild('setupForm') setupForm: NgForm;

  protected readonly states = US_STATES;

  model: GCProject = {
    id: null,
    auto_generated_project_id: null,
    custom_project_id: '',
    title: '',
    start_date: null,
    anticipated_completion_date: null,
    location: '',
    city: '',
    status: null,
    address: '',
    state: '',
    zip: '',
  };

  customIdEditable = false;
  originalCustomId = null;
  hasCustomId = false;

  ngOnInit() {
    super.ngOnInit();

    if (this.isInvitationAccept()) {
      const project = this.invitationBeingAccepted().project;
      this.model = {
        ...this.model,
        title: project.title,
        start_date: project.start_date,
      };
      this.startDateChanged(this.model.start_date);
    } else {
      // if isEdit
      this.actions
        .pipe(
          takeUntil(this.isDestroyed$),
          ofType(projectActions.editProjectDataLoaded),
          delay(100),
        )
        .subscribe((action) => {
          console.log('editProjectDataLoaded action', action);
          const project = action.project as GCProject;
          this.model = DeepCopyService.deepCopy<GCProject>(project);
          // can edit template if no commitments
          this.originalCustomId = project.auto_generated_project_id;
          this.hasCustomId = project.custom_project_id !== project.auto_generated_project_id;
          if (this.hasCustomId) {
            this.customIdEditable = true;
          }
        });
    }
  }

  updateProjectId({ year }: { year?: number }) {
    if (!year) {
      return;
    }

    this.projectService.getNextProjectId({ property_id: null, year }).subscribe((response) => {
      this.model.custom_project_id = response.next_custom_id;
      this.originalCustomId = response.next_custom_id;
    });
  }

  startDateChanged(date: string) {
    if (!this.isEdit) {
      this.updateProjectId({ year: dayjs(date).year() });
    }
  }
}
